import React from 'react';
import styles from './Service.module.css';
import { GoArrowUpRight } from "react-icons/go";
import { useInView } from 'react-intersection-observer';

// Helper component for animating elements (remains the same)
const AnimatedDiv = ({ children, baseClass, animationClass, initialClass, threshold = 0.1, triggerOnce = false }) => {
    const { ref, inView } = useInView({
        threshold: threshold,
        triggerOnce: triggerOnce,
    });

    let combinedClassName = baseClass ? `${baseClass} ` : '';
    combinedClassName += inView ? animationClass : initialClass;
    
    return (
        <div ref={ref} className={combinedClassName}>
            {children}
        </div>
    );
};

// Service Data Array (remains the same)
const servicesData = [
    {
        id: 'branding',
        title: "Branding",
        items: [
            "Brand Name", "Brand Strategy", "Logo Design", "Marketing Brochures",
            "Social Banners", "Social Grid Branding", "Brand Guidelines"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301171/Landing_page-bro_kkocfr.png",
        imageAlt: "branding"
    },
    {
        id: 'marketing',
        title: "Marketing",
        items: [
            "Marketing Consultancy", "Brand Positioning", "Brand Advisory Service"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301175/Interaction_Design-pana_lzmyxa.png",
        imageAlt: "marketing"
    },
    {
        id: 'digital-marketing',
        title: "Digital Marketing",
        items: [
            "Ad Campaign Strategy", "Ad Management", "Content Creation - Copywriting",
            "Digital Advertising - Social Media Ads", "Google Ads", "SEO Analytics and Reporting"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301175/Mobile_Marketing-pana_my2tfp.png",
        imageAlt: "digital marketing"
    },
    {
        id: 'pr-influencer',
        title: "PR & Influencer Marketing",
        items: [
            "Press Releases", "Media Relations", "Influencer Partnerships",
            "Brand Storytelling", "Crisis Management", "Reputation Management"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301174/Influencer-pana_fzfo6q.png",
        imageAlt: "pr"
    },
    {
        id: 'web-app-design',
        title: "Website & App Design",
        items: [
            "Custom Website Design & Development", "E-Commerce Websites", "Portfolio Websites",
            "Shopify Websites", "WordPress Websites", "Custom Web App Design & Development"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301173/Website_Creator-bro_feyenb.png",
        imageAlt: "web design"
    },
    {
        id: 'production',
        title: "Production",
        items: [
            "Brand Kits", "Business Cards", "Letterheads", "Envelopes",
            "Packaging", "Marketing Collaterals", "Tent Cards"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301174/Font-pana_i4yazl.png",
        imageAlt: "production"
    },
    {
        id: 'photo-video',
        title: "Photography / Videography",
        items: [
            "Site Shoot", "Product Styling", "Product Photography",
            "Model Photography", "Promotional Videos"
        ],
        imageUrl: "https://res.cloudinary.com/dj9toibx5/image/upload/v1747301176/Videographer-pana_xxwzql.png",
        imageAlt: "photo video"
    }
];


function Service() {
    const headerAnimationProps = {
        baseClass: styles.header,
        initialClass: styles.elementInitialState,
        animationClass: styles.elementVisibleAnimate,
        triggerOnce: true,
        threshold: 0.1,
    };

    const cardAnimationProps = {
        baseClass: styles['service-card'],
        initialClass: styles.elementInitialState,
        animationClass: styles.elementVisibleAnimate,
        triggerOnce: false,
        threshold: 0.15,
    };

    const handleWhatsAppRedirect = (serviceTitle) => {
        const yourPhoneNumber = "919818825449"; // Your WhatsApp number
        const currentUrl = window.location.href; // Get the current website URL

        // Construct the message
        const message = `${currentUrl} \n\n I want to know more about "${serviceTitle}".`;

        const whatsappUrl = `https://wa.me/${yourPhoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className={styles['service-container']}>
            <AnimatedDiv {...headerAnimationProps}>
                <h1>#बाजार</h1>
                <h2>The Buzz Menu</h2>
                <p>Pick a service to download your success</p>
            </AnimatedDiv>

            <div className={styles['service-cards']}>
                {servicesData.map((service) => (
                    <AnimatedDiv {...cardAnimationProps} key={service.id}>
                        <div className={styles['service-header-design']}>{service.title}</div>
                        <div className={styles['service-card-container']}>
                            <div className={styles['service-card-clip']}>
                                <ul className={styles['service-list']}>
                                    {service.items.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                            <img
                                src={service.imageUrl}
                                alt={service.imageAlt}
                                className={styles['service-card-image']}
                            />
                        </div>
                        <button
                            className={styles['download-btn']}
                            onClick={() => handleWhatsAppRedirect(service.title)}
                            aria-label={`Enquire about ${service.title} on WhatsApp`}
                        >
                            <GoArrowUpRight />
                        </button>
                    </AnimatedDiv>
                ))}
            </div>
        </div>
    );
}
export default Service;